export default {
  name: 'Somalia',
  phonePattern: '',
  postalCodePattern: 'AA11111',
  singlePostalCode: '',
  postalCodeRegex: '^([A-Za-z]){2}([\\d]){5}$',
  language: '',
  dobFormat: 'DD/MM/YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/SO.js